import styled from "@emotion/styled";
import React from "react";
import { Typography } from "../Typography";

export const GOOGLE_PRIVACY_POLICY_URL = "https://policies.google.com/privacy";
export const GOOGLE_PRIVACY_POLICY_TEXT = "Privacy Policy";
export const GOOGLE_TERMS_OF_SERVICE_URL = "https://policies.google.com/terms";
export const GOOGLE_TERMS_OF_SERVICE_TEXT = "Terms of Service";
export const RECAPTCHA_TEST_ID = "recaptcha-policy";

const StyledText = styled(Typography)`
  color: ${({ theme }) => theme.colors.charcoalLight};
`;

export const RecaptchaPolicy = ({ className }: { className?: string }) => (
  <StyledText
    className={className}
    use="dashboardMicroCopyRegular"
    data-testid={RECAPTCHA_TEST_ID}
  >
    {`This site is protected by reCAPTCHA and the Google `}
    <StyledText
      use="dashboardMicroLinkRegularInline"
      href={GOOGLE_PRIVACY_POLICY_URL}
      rel="noopener noreferrer"
      target="_blank"
    >
      {GOOGLE_PRIVACY_POLICY_TEXT}
    </StyledText>
    {` and `}
    <StyledText
      use="dashboardMicroLinkRegularInline"
      href={GOOGLE_TERMS_OF_SERVICE_URL}
      rel="noopener noreferrer"
      target="_blank"
    >
      {GOOGLE_TERMS_OF_SERVICE_TEXT}
    </StyledText>
    {` apply.`}
  </StyledText>
);
